<div *let="isAnalyzingClauseVarianceLoading$ | async as loading">
  <div *let="isLoadingReviewData$ | async as loadingReviewData">
    <div class="row-with-title clause-variance-analysis__breadcrumbs">
      <div class="col-title">
        <span class="link-like" (click)="goToWorkspaces()">{{
          'workspaces.myWorkspaces' | transloco
        }}</span>
        @if (workspaceDetails) {
          >
          <span class="link-like" (click)="goToWorkspaceDetails()">{{
            workspaceDetails.name
          }}</span>
          >
          {{ 'workspaces.clauseVarianceAnalysis' | transloco }}
        }
      </div>
      <div class="col-pdf-button">
        <p-splitButton
          class="split-btn export-split-btn"
          [model]="exportMenuItems"
          [disabled]="loading || loadingReviewData || isExporting"
          (onClick)="onPrimaryExportClick()"
        >
          <ng-template pTemplate="content">
            <span class="export-split-btn__label">
              <span>{{ 'buttons.export' | transloco }}</span>
            </span>
          </ng-template>
        </p-splitButton>
      </div>
    </div>

    @if (!loading) {
      <div class="clause-variance-analysis__content">
        <app-analyzing-clause-variance-progress-bar></app-analyzing-clause-variance-progress-bar>

        <div class="row">
          <div class="col">
            <mat-tab-group
              class="common-app-tabs clause-variance-analysis__tabs"
              mat-stretch-tabs="false"
              mat-align-tabs="start"
              animationDuration="0ms"
            >
              <mat-tab label="{{ 'workspaces.dashboard' | transloco }}">
                <app-analyzing-clause-variance-dashboard></app-analyzing-clause-variance-dashboard>
              </mat-tab>
              <mat-tab label="{{ 'workspaces.overview' | transloco }}">
                <app-analyzing-clause-alignment-matrix> </app-analyzing-clause-alignment-matrix>
              </mat-tab>
              <mat-tab label="{{ 'workspaces.clauseVarianceAnalysis' | transloco }}">
                <app-analyzing-clause-alignment-detailed></app-analyzing-clause-alignment-detailed>
              </mat-tab>
            </mat-tab-group>
          </div>
        </div>
      </div>
    }

    @if (loading) {
      <div class="clause-variance-loading">
        <div class="spinner-border" role="status"></div>
        <div class="clause-variance-loading__title">
          {{ 'workspaces.analyzingClauseVariance' | transloco }}
        </div>
        <div class="clause-variance-loading__text">
          {{ 'workspaces.comparingWorkspaceDocuments' | transloco }}
        </div>
        <div class="clause-variance-loading__text">
          {{ 'workspaces.thisMayTakeAMoment' | transloco }}
        </div>
      </div>
    }
  </div>
</div>

<div class="long-time-loader non-blocking" [hidden]="!isExportNotificationVisible">
  <div class="status-text">
    <div class="spinner-border" role="status"></div>
    <div class="info-text">
      <b>{{ 'text.generatingReport' | transloco }}</b>
      {{ 'text.generatingClauseVarianceReportInProgress' | transloco }}
    </div>
  </div>
</div>
